import React from 'react';
//import { useNavigate } from "react-router-dom";


import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp,
} from '../../services/AuthService';


export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';



export function signupAction(email, password, navigate) {
	console.log('signupAction')
    return (dispatch) => {
        signUp(email, password)
        .then((response) => {
            saveTokenInLocalStorage(response.data);
            runLogoutTimer(
                dispatch,
                response.data.expiresIn * 1000,
                //history,
            );
            dispatch(confirmedSignupAction(response.data));
            navigate('/dashboard');
			//history.push('/dashboard');
        })
        .catch((error) => {
            const errorMessage = formatError(error.response.data);
            dispatch(signupFailedAction(errorMessage));
        });
    };
}

export function Logout(navigate) {
    localStorage.removeItem('userDetails');
    
    if (window.location.pathname !== "/usuarios" && window.location.pathname !==  "/wpp-login") {
        navigate('/login');
    }
    
    return {
        type: LOGOUT_ACTION,
    };
}

// export function loginAction(userName, Password, navigate) {
//     console.log('--- loginAction ---') 
//     return (dispatch) => {
//          login(userName, Password)
//             .then((response) => { 
//                 console.log("--- response ---")
//                 console.log(response)
//                 saveTokenInLocalStorage(response.data);
//                 runLogoutTimer(
//                     dispatch,
//                     response.data.expiresIn * 1000,
//                     // navigate,
//                 );
//                dispatch(loginConfirmedAction(response.data));
// 			   //console.log('kk------1');
// 			   //console.log(kk);
// 			   //console.log(response.data);
// 			   //console.log('kk------2');
// 			   //return response.data;
// 				//return 'success';
// 				//history.push('/dashboard');                
// 				navigate('/dashboard');                
//             })
//             .catch((error) => {
//                 console.log("--- error ---")
//                 console.log(error)
//                 const errorMessage = formatError(error.response.data);
//                 dispatch(loginFailedAction(errorMessage));
//             });
//     };
// }

export function loginAction(userName, Password, captcha, resolve, reject) {
    return (dispatch) => {
         login(userName, Password, captcha)
            .then((response) => { 
                saveTokenInLocalStorage(response, userName);
                runLogoutTimer(
                    dispatch,
                    "3600" * 1000
                );
                dispatch(loginConfirmedAction(response));
                if (resolve) resolve();
            })
            .catch((error) => {
                const errorMessage = error.response?.data?.message || 'Erro ao realizar login. Verifique suas credenciais.';
                dispatch(loginFailedAction(errorMessage));
                if (reject) reject(error);
            });
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
